import abstractModel from "../../core/ShopModel";

const resource = 'retailers/categories';

const model = abstractModel(resource);

export default model;
